var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "booking-status" }, [
    _vm.bookingLabel
      ? _c(
          "div",
          {
            staticClass: "status",
            class: _vm.bookingLabel.class,
            staticStyle: {
              "text-overflow": "ellipsis",
              "white-space": "nowrap",
              "overflow-x": "hidden",
              "text-align": "center",
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.bookingLabel.label) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.booking.urgent
      ? _c("span", { staticClass: "status status-bad" }, [_vm._v("Urgent")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }